import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatbotComponent } from '../chatbot/chatbot.component';
import { FormsModule } from '@angular/forms';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';

@NgModule({
  declarations: [
    ChatbotComponent // 1. Declare the reusable component here
  ],
  imports: [
    CommonModule,
    FormsModule,
    Ng2GoogleChartsModule
  ],
  exports: [
    ChatbotComponent // 2. Export the component to make it available to other modules
  ]
})
export class SharedModule { }